import { EventBusKey } from '@/util/bus'
import EventBus from '@/util/bus'
import { verifyResponseSignature } from '@/util/verifySignature'
import { getVersionByUp } from '@/util/version'
import HttpRequest from '@yige/request'
import axios, { CreateAxiosDefaults } from 'axios'

export const isTest = process.env.VUE_APP_ENV !== 'production'
export const httpRequest = new HttpRequest({
  baseUrl: process.env.VUE_APP_BASE_URL,
  timeout: 1000000,
  tokenKey: 'token',
  cacheTokenMethods: 'sessionStorage',
  isValidStatus(response) {
    noticeUserReload(response)
    return true
  },
  headers: {
    bluen_version: getVersionByUp(),
  },
})

httpRequest.requestInstance.interceptors.response.use((response: any) => {
  return verifyResponseSignature(response)
})

// 所有请求都需要保证其携带上 bluen_version 字段
axios.interceptors.request.use((config) => {
  config.headers.bluen_version = getVersionByUp()
  return config
})
axios.interceptors.response.use((response) => {
  noticeUserReload(response.data)
  return verifyResponseSignature(response)
})

/**
 * @description 创建全局配置的 Axios 实例。该方法用于统一创建项目中所有的 Axios 实例，确保全局配置和拦截器的一致性。所有需要使用 Axios 的地方都应通过此方法创建实例。
 * @param config 配置
 */
export function createAxiosWithGlobal(config: CreateAxiosDefaults) {
  const instance = axios.create(config)
  // 所有请求都需要保证其携带上 bluen_version 字段
  instance.interceptors.request.use((config) => {
    config.headers.bluen_version = getVersionByUp()
    return config
  })
  instance.interceptors.response.use((response) => {
    noticeUserReload(response.data)
    return verifyResponseSignature(response)
  })
  return instance
}

/**
 * @description 通知用户需要重新load
 * @param response 响应报文
 */
function noticeUserReload(response: { refresh: boolean }) {
  if (response?.refresh) {
    EventBus.$emit(EventBusKey.NOTICE_USER_RELOAD)
  }
}
